import { atom, selector } from 'recoil'

export interface GameCoursewareItem {
  image: string
  background: string
  backgroundWeb: string
  // 选项图地址
  imageWeb: string
  // 选项ID
  id: number
}

export interface GameCourseware {
  lottieJson: string
  errorAudios: string[]
  // 错误音效
  errorAudiosWeb: string[]
  subject: string
  // 题干 type=1时是文字题干 type=2时是图片题干
  subjectWeb: string
  background: string
  // 背景
  backgroundWeb: string
  // 题干的类型 1 文字 2 图片（注意是字符串类型）
  type: string
  scene: string
  // 正确答案与items中的ID匹配
  result: number
  rightAudios: string[]
  // 正确音效
  rightAudiosWeb: string[]
  sound: string
  // 题干的音乐
  soundWeb: string
  // 选项
  items: GameCoursewareItem[]
}

export interface CoursewareList {
  zip?: string | null
  // courseType = 3时取json
  json?: GameCourseware | null
  coverUrl?: string
  coverUrlWeb?: string
  standardLabel?: string
  metadataId?: string
  title?: string | null
  url?: string
  width?: number
  height?: number
  type: number // 0 站位，兼容以前的历史图片 1 历史图片 2 课件图片 3 自带课件
  sort?: number
  small_url?: string
  pic_word?: string
  lines: any[] // TODO
  picUrl: string
  picId: string
  text?: string
  courseId?: number
  // 1 图片课件 2 视频课件 3 互动课件
  courseType: number
  picWidth?: number
  picHeight?: number
  zipUrl?: string | null
  jsonConfig?: string
}

export interface DrawLine {
  windowId: string
}

export interface PicLayout {
  xScale: number
  yScale: number
  zoomScale: number
  courseId: string
}

// 画线
export const drawLineDataState = atom<DrawLine[]>({
  key: 'drawLineData',
  default: []
})

// 当前课件的画线
export const viewDrawLineState = selector<DrawLine | undefined>({
  key: 'viewDrawLine',
  // get支持异步
  get: ({ get }) => {
    const drawLineData = get(drawLineDataState)
    const viewPicId = get(viewPicIdState)
    return drawLineData.find((v) => v.windowId === viewPicId)
  }
})

// 课件滚动缩放
export const picLayoutState = atom<PicLayout>({
  key: 'picLayout',
  default: {
    xScale: 0,
    yScale: 0,
    zoomScale: 0,
    courseId: ''
  }
})

// 图片课件
export const coursewareListState = atom<CoursewareList[]>({
  key: 'coursewareList',
  default: [
    // {
    //   zip: null,
    //   json: null,
    //   coverUrl: 'https://s2.xiaoxiongmeishu.com/teach/dev/one/4286/4286v9/chapter_1/1.png',
    //   coverUrlWeb: 'https://s2.xiaoxiongmeishu.com/teach/dev/one/4286/4286v9/chapter_1/1.png',
    //   standardLabel: '1',
    //   metadataId: '97034',
    //   title: null,
    //   url: 'https://s2.xiaoxiongmeishu.com/teach/dev/one/4286/4286v9/chapter_1/1.png',
    //   width: 116,
    //   height: 160,
    //   type: 3,
    //   sort: 0,
    //   small_url: 'https://s2.xiaoxiongmeishu.com/teach/dev/one/4286/4286v9/chapter_1/1.png',
    //   pic_word: '提词器上了；阿附近时；阿雷锋精神；阿雷锋科技时代；拉风教室；阿附近时；阿附近时大；飞机撒；打飞机撒',
    //   lines: [],
    //   picUrl: 'https://s2.xiaoxiongmeishu.com/teach/dev/one/4286/4286v9/chapter_1/1.png',
    //   picId: '1',
    //   text: '提词器上了；阿附近时；阿雷锋精神；阿雷锋科技时代；拉风教室；阿附近时；阿附近时大；飞机撒；打飞机撒',
    //   courseId: 0,
    //   courseType: 1,
    //   picWidth: 116,
    //   picHeight: 160,
    //   zipUrl: null,
    //   jsonConfig: 'null'
    // }
  ]
})

export interface VideoCoursewareList {
  videoTitle: string
  videoURL: string
}

// 视频课件
export const videoCoursewareListState = atom<VideoCoursewareList[]>({
  key: 'videoCoursewareList',
  default: [
    // {
    //   videoTitle: '视频备份描述1',
    //   videoURL: 'https://s2.xiaoxiongmeishu.com/teach/dev/1v1/one/course/video/17a1cc40a38911ed9ff3bf773dd71fd1.mp4'
    // }
  ]
})

// 提词器
export const captionsState = atom<boolean>({
  key: 'captions',
  default: false
})

// 画笔授权 false 学员 true 老师
export const penStateState = atom<boolean>({
  key: 'penState',
  default: true
})

// 试听课点评窗口
export const courseAssessState = atom<boolean>({
  key: 'courseAssess',
  default: false
})

// 当前课件
export const viewPicIdState = atom<string>({
  key: 'viewPicId',
  default: 'default_disImage'
})

// 当前课件的下标
export const viewPicIdIndexState = selector<number>({
  key: 'viewPicIdIndex',
  // get支持异步
  get: ({ get }) => {
    const coursewareList = get(coursewareListState)
    const viewPicId = get(viewPicIdState)
    return coursewareList.findIndex((v) => v.picId === viewPicId)
  }
})

// 画笔颜色
export const lineColorState = atom<string>({
  key: 'lineColor',
  default: '#E02020'
})

// 画笔宽度
export const lineWidthState = atom<number>({
  key: 'lineWidth',
  default: 3
})

// 视频播放状态
export const autoplayState = atom<boolean>({
  key: 'autoplay',
  default: true
})
